module.exports = __webpack_public_path__ + "static/img/fan-default.a9e1190c.png";